import { render, staticRenderFns } from "./ReceivePriceSearch.vue?vue&type=template&id=5922e31a&"
import script from "./ReceivePriceSearch.vue?vue&type=script&lang=js&"
export * from "./ReceivePriceSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports